import { Typography } from '@mui/material';
import React from 'react';
import { ErrorReference, GraphQlRequestErrorCode } from '../../../../api/types';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

interface IpForbiddenErrorProps {
  fromIpAddress: string | null;
  errorCode: GraphQlRequestErrorCode;
  errorReference: ErrorReference | null;
}

const IpForbiddenErrorComponent = (props: IpForbiddenErrorProps) => {
  const { fromIpAddress, errorCode, errorReference } = props;

  return (
    <Error
      title={{ key: 'pages:errorBoundary.ipForbiddenTitle' }}
      message={(t) => (
        <>
          <Typography variant="h5">
            {fromIpAddress === null
              ? t('pages:errorBoundary.ipForbiddenExplanationNoIp')
              : t('pages:errorBoundary.ipForbiddenExplanation', {
                  ip: fromIpAddress,
                })}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, maxWidth: '600px' }}>
            {fromIpAddress === null
              ? t('pages:errorBoundary.ipForbiddenGuidanceNoIp')
              : t('pages:errorBoundary.ipForbiddenGuidance')}
          </Typography>
          <ErrorTechnicalDetails
            errorCode={errorCode}
            errorReference={errorReference}
          />
        </>
      )}
    />
  );
};

export default IpForbiddenErrorComponent;
